export default "__VITE_ASSET__CN3vf9fb__"